import { useSearchParams } from 'react-router';
import { ExperimentStatusKind } from '@gonfalon/experiments/types';
import type { IconName } from '@launchpad-ui/icons';

import { useExperimentIterationContext } from '#components/experimentation/common/providers/ExperimentIterationContextProvider';

export enum ChartType {
  PROBABILITY = 'probability',
  DIFFERENCE = 'difference',
  FOREST = 'forest',
  ARM_AVERAGES = 'arm-averages',
  RESULTS_TABLE = 'results-table',
}

export const chartTypeIcons: Record<ChartType, IconName> = {
  [ChartType.PROBABILITY]: 'chart-bell',
  [ChartType.DIFFERENCE]: 'chart-cube-root',
  [ChartType.ARM_AVERAGES]: 'chart-lines-crossed',
  [ChartType.FOREST]: 'chart-forest',
  [ChartType.RESULTS_TABLE]: 'layout-structured',
};

export function useExperimentResultsChartType(): { chartType: ChartType; setChartType: (type: ChartType) => void } {
  const [searchParams, setSearchParams] = useSearchParams();
  const { experiment, iteration } = useExperimentIterationContext();
  const searchParamsChartType = searchParams.get('chartType');
  let chartType: ChartType = ChartType.RESULTS_TABLE;
  if (experiment.methodology === 'frequentist' && iteration.status !== ExperimentStatusKind.NOT_STARTED) {
    chartType = ChartType.FOREST;
  }
  if (searchParamsChartType && Object.values(ChartType).includes(searchParamsChartType as ChartType)) {
    chartType = searchParamsChartType as ChartType;
  }
  if (chartType !== ChartType.FOREST) {
    chartType = ChartType.RESULTS_TABLE;
  }
  return {
    chartType,
    setChartType: (type: ChartType) => {
      searchParams.set('chartType', type);
      setSearchParams(searchParams, { preventScrollReset: true });
    },
  };
}
